import { reactive } from 'vue';

// 전역 로딩 상태 ( pending: 진행중 요청 수, visible: 오버레이 노출 여부 )
export const loadingState = reactive({
	pending: 0,
	visible: false,
});

const SHOW_DELAY = 200; // 깜빡임 방지 지연시간 (ms)
const HIDE_DELAY = 300; // 마지막 응답 후 오버레이를 내리기까지의 유예시간 (ms)
let showTimer = null;
let hideTimer = null;

// 요청 시작
export function startLoading() {
	loadingState.pending++;
	// 종료 예약이 걸려 있으면 취소
	if (hideTimer) {
		clearTimeout(hideTimer);
		hideTimer = null;
	}
	// 첫 요청이고 아직 노출 전일 때만 지연 타이머 시작
	if (loadingState.pending === 1 && !loadingState.visible && !showTimer) {
		showTimer = setTimeout(() => {
			showTimer = null;
			if (loadingState.pending > 0) loadingState.visible = true;
		}, SHOW_DELAY);
	}
}

// 요청 종료
export function endLoading() {
	loadingState.pending = Math.max(0, loadingState.pending - 1);
	// 아직 진행중인 요청이 남아 있을 시
	if (loadingState.pending > 0) return;

	// 진행중 요청이 없어도 곧바로 숨기지 않고 유예시간 동안 기다렸다가 숨김
	if (hideTimer) clearTimeout(hideTimer);
	hideTimer = setTimeout(() => {
		hideTimer = null;
		if (loadingState.pending === 0) {
			clearTimeout(showTimer);
			showTimer = null;
			loadingState.visible = false;
		}
	}, HIDE_DELAY);
}

// 로딩 표시 제외 대상 ( 백그라운드 호출 )
const SILENT_URLS = [
	'/sys/cntnStats/'              // 접속 통계 등록
	, '/sys/thema/'                // 라우팅마다 도는 테마 버전 체크
	, '/refresh/tokenReissue.json' // 토큰 재발급
];

// 로딩 표시 제외 여부
function isSilent(config) {
	if (config?.skipLoading) return true;
	return SILENT_URLS.some(url => (config?.url || '').includes(url));
}

// axios 인스턴스에 로딩 인터셉터 연결
export function attachLoading(instance) {
	instance.interceptors.request.use(
		config => {
			if (!isSilent(config)) {
				config._loading = true;
				startLoading();
			}
			return config;
		},
		error => {
			return Promise.reject(error);
		}
	);

	instance.interceptors.response.use(
		response => {
			if (response.config?._loading) endLoading();
			return response;
		},
		error => {
			// 세션 만료 처리는 resolve 되지 않는 프로미스를 반환하므로 여기서 먼저 감소
			if (error.config?._loading) endLoading();
			return Promise.reject(error);
		}
	);
}
